import { atom, useRecoilState } from 'recoil';

const recoilAtoms = new Map();
const dummyAtom = atom({ key: 'dummyLegacy', default: null });

const useDynamicRecoil = (recoilKey: string | undefined, initialValue: any) => {
  if (recoilKey && !recoilAtoms.has(recoilKey)) {
    recoilAtoms.set(
      recoilKey,
      atom({
        key: recoilKey,
        default: initialValue,
      }),
    );
  }

  const [recoilValue, setRecoilValue] = useRecoilState<any>(recoilKey ? recoilAtoms.get(recoilKey) : dummyAtom);

  return [recoilValue, setRecoilValue];
};

export default useDynamicRecoil;
